import { cn } from '@/lib/utils';

enum Size {
    large = 'large',
    medium = 'medium',
    small = 'small',
}
const SizeClassName = {
    [Size.large]: 'h-12 w-12 min-w-12 border-[7px]',
    [Size.medium]: 'h-10 w-10 border-[6px]',
    [Size.small]: 'h-8 w-8 border-[5px]',
};

export function RoundLoading({
    size = Size.medium,
    className,
}: {
    className?: string;
    size?: 'large' | 'medium' | 'small';
}) {
    return (
        <div
            className={cn(
                'relative flex min-h-10 w-full flex-col items-center justify-center',
                className
            )}
        >
            <div
                className={cn(
                    'flex animate-spin items-center justify-center rounded-full border-gray-300 border-t-primary text-4xl text-blue-400',
                    SizeClassName[size]
                )}
            ></div>
        </div>
    );
}
